import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useRole } from '../../contexts/RoleContext';
import { Box, CircularProgress } from '@mui/material';

const AuthRoute = ({ children }) => {
  const { currentUser, loading: authLoading } = useAuth();
  const { loading: roleLoading } = useRole();

  // Show loading state while checking authentication
  if (authLoading || roleLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}
      >
        <CircularProgress sx={{ color: '#1B5E20' }} />
      </Box>
    );
  }

  // If user is already authenticated, redirect to landing page
  if (currentUser) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AuthRoute; 